import lozad from 'lozad'
import {header} from '../index/scripts/header'
$(document).ready(function () {
	stickyElement()
	header.init()
	clickScrollToDiv()
})
function stickyElement () {
	const heightHeader = $('.header-2').outerHeight();
	$('.sticky-tab-static').sticky({topSpacing: heightHeader, zIndex: 30})
	$('.sticky-tab-static').on('sticky-start', function () {
		$(this).addClass('is-sticky')
	})
	$('.sticky-tab-static').on('sticky-end', function () {
		$(this).removeClass('is-sticky')
	})
	// if (window.matchMedia('(min-width: 768px)').matches) {
	// 	$('.sticky-tab-static').clone().addClass('sticky-tab').prependTo('.append-tab')
	// 	var sticky = new Sticky('.sticky-tab');
	// 	sticky.update()
	// } else {
	// }
}
function clickScrollToDiv() {
	var enableDisableElements = $('.section-services-content')
	for (var i = 0, length = enableDisableElements.length; i < length; i++) {
		new Waypoint({
			element: enableDisableElements[i],
			handler: function (direction) {
				const _index = $(this.element).attr('id')
				$(`.item-service[href="#${_index}"]`)
					.parent()
					.addClass('active')
					.siblings()
					.removeClass('active')
			},
			offset: '35%',
		})
	}

	$('.item-service').on('click', function (e) {
		e.preventDefault()
		// waypoints.disableAll();
		Waypoint.disableAll()
		const id = $(this).attr('href')
		$('html, body').animate(
			{
				scrollTop:
					$(id).offset().top -
					$('.header-2').outerHeight() -
					$('.section-services.tab').outerHeight(),
			},
			800
		)
		$(this).parent().addClass('active').siblings().removeClass('active')
		setTimeout(() => {
			Waypoint.enableAll()
		}, 1000)
		return false
	})
}
/*==================== Lazyload JS ====================*/
const observer = lozad() // lazy loads elements with default selector as '.lozad'
observer.observe()
